<mat-nav-list fxLayout="column" *ngIf="!isAuthenticated" fxFlex (click)="sidenavRef.toggle()">
  <div *ngIf="headerLoggedOutSettings?.length; else noHeaders">
    <ng-container *ngFor="let item of headerLoggedOutSettings;">

      <ng-container *ngIf="headerLoggedOutSettings && currentNavList === NavLists.claims; then claimsNavList">
      </ng-container>

      <ng-container *ngIf="item.LinkUrl.startsWith('http'); else profileBlock">
        <a
          mat-list-item
          [href]="item.LinkUrl"
          [target]="item.OpenNewTab ? '_blank' : '_self'"
          routerLinkActive="active"
          [gtmClick]="item.Caption"
          gtmLinkURL="Header Link">
          {{ item.Caption }}
        </a>
        <mat-divider></mat-divider>
      </ng-container>

      <ng-template #profileBlock>


        <a
          *ngIf="item.LinkUrl === '^program_information' && currentNavList !== NavLists.claims"
          mat-list-item
          routerLinkActive="active"
          href="javascript:void(0);"
          (click)="showChildren($event)"
          [gtmClick]="item.Caption"
          gtmLinkURL="Header Link">
          {{ item.Caption }}
        </a>
        <a
          *ngIf="item.LinkUrl !== '^program_information' && currentNavList !== NavLists.claims"
          mat-list-item
          [routerLink]="item.LinkUrl"
          routerLinkActive="active"
          gtmClick="Profile"
          gtmLinkURL="Header Link">
          {{ item.Caption }}
        </a>
      </ng-template>



    </ng-container>

    <ng-container *ngIf="chooseLanguage">
      <mat-divider></mat-divider>
      <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);"
        (click)="toggleLanguage()">{{chooseLanguage}}</a>
    </ng-container>
  </div>

  <ng-template #noHeaders>
    <ng-container *ngIf="chooseLanguage">
      <a [title]="chooseLanguageTitle" class="language-toggle language-noheaders" href="javascript:void(0);"
        (click)="toggleLanguage()">{{chooseLanguage}}</a>
    </ng-container>
  </ng-template>

  <ng-template #claimsNavList>

    <ng-container *ngIf="programInfoLinks?.length">
      <a mat-list-item class="link-primary-dark" (click)="backClick($event);">
        <adp-label labelKey="Global_Header_BackToMainMenu"></adp-label>
      </a>
      <a
        mat-list-item
        *ngFor="let childItem of programInfoLinks"
        [gtmClick]="childItem.Caption"
        gtmLinkURL="Header Claims Link"
        (click)="this.programLinkClick(childItem)">
        {{ childItem.Caption }}
        <mat-divider></mat-divider>
      </a>
    </ng-container>
  </ng-template>

</mat-nav-list>
